<div
  class="flex flex-col"
  [ngClass]="{ 'on-error': sectionFormControl.hasError('body') }"
>
  <div class="space-x-3 bg-project-600 rounded-t-md text-project-2400">
    <h3
      *ngIf="!isSlide"
      class="mat-expansion-panel-header text-sm text-inherit h-[43px] flex items-center py-0 px-6"
    >
      {{ title }}
    </h3>
  </div>
  <div
    class="flex flex-col items-center justify-center h-[600px] animate-pulse"
    *ngIf="(editorSubject | async) === null"
  >
    <mat-spinner [diameter]="50" [strokeWidth]="5"></mat-spinner>
    <p class="italic">Loading the editor...</p>
  </div>
  <div class="flex flex-col space-y-4">
    <editor
      [init]="settings"
      [disabled]="true"
      (onInit)="onEditorInit($event)"
      [formControl]="sectionFormControl"
    ></editor>
    <div *ngIf="sectionImgsFormControl && sectionVideosFormControl">
      <app-media-adder
        *ngIf="!isDisabled"
        [sectionImgsFormControl]="sectionImgsFormControl"
        [sectionVideosFormControl]="sectionVideosFormControl"
        [addMediaLabel]="'Add inline'"
        (handleInsertImg)="onAddInlineImg($event)"
        (handleInsertVideo)="onAddInlineVideo($event)"
        (handleRemoveImg)="onRemoveImg($event)"
        (handleRemoveVideo)="onRemoveVideo($event)"
      ></app-media-adder>
    </div>
  </div>
</div>
